'use client'

import { useTheme } from '../hooks/useTheme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'

export default function ThemeToggle() {
  const { theme, toggleTheme, mounted } = useTheme()

  if (!mounted) {
    return (
      <div className="w-10 h-10 rounded-lg bg-mystic-800/50 animate-pulse" />
    )
  }

  return (
    <button
      onClick={toggleTheme}
      className="relative w-10 h-10 rounded-lg bg-mystic-800/50 hover:bg-mystic-700/50 
                 dark:bg-mystic-800/50 dark:hover:bg-mystic-700/50
                 border border-mystic-600/30 hover:border-mystic-500/50
                 dark:border-mystic-600/30 dark:hover:border-mystic-500/50
                 transition-all duration-300 ease-out
                 flex items-center justify-center
                 hover:scale-105 active:scale-95"
      aria-label={theme === 'light' ? '切换到深色模式' : '切换到浅色模式'}
    >
      <div className="relative w-5 h-5">
        {/* 太阳图标 */}
        <FontAwesomeIcon 
          icon={faSun}
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ease-out
            ${theme === 'light' 
              ? 'opacity-100 rotate-0 scale-100 text-yellow-500' 
              : 'opacity-0 rotate-90 scale-0 text-yellow-500'
            }`}
        />
        {/* 月亮图标 */}
        <FontAwesomeIcon 
          icon={faMoon}
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ease-out
            ${theme === 'dark' 
              ? 'opacity-100 rotate-0 scale-100 text-blue-300' 
              : 'opacity-0 -rotate-90 scale-0 text-blue-300'
            }`}
        />
      </div>
      {/* 光效 */}
      <div className={`absolute inset-0 rounded-lg transition-all duration-300
        ${theme === 'light' 
          ? 'bg-gradient-to-r from-amber-500/20 to-orange-500/20' 
          : 'bg-gradient-to-r from-mystic-500/20 to-indigo-500/20'
        }`} 
      />
    </button>
  )
}